import { withPrefix } from 'gatsby';
import { ROUTES } from './routes';

export const isProductListOverviewPage = (pathname: string): boolean => pathname.startsWith(withPrefix(ROUTES.SEARCH));
